import { Sector } from 'recharts-v2';
export var renderActiveShape = function (_a) {
    var value = _a.value, fillColorClass = _a.fillColorClass, chartConfig = _a.chartConfig, shapeProps = _a.shapeProps, name = _a.name, cornerRadius = _a.cornerRadius, _b = _a.hideIndicator, hideIndicator = _b === void 0 ? false : _b;
    var RADIAN = Math.PI / 180;
    var cx = shapeProps.cx, cy = shapeProps.cy, innerRadius = shapeProps.innerRadius, outerRadius = shapeProps.outerRadius, startAngle = shapeProps.startAngle, endAngle = shapeProps.endAngle;
    var DATA_POINT_OUTER_R = chartConfig.DATA_POINT_OUTER_R, DATA_POINT_INNER_R = chartConfig.DATA_POINT_INNER_R, DATA_POINT_STROKE_WIDTH = chartConfig.DATA_POINT_STROKE_WIDTH;
    var dataPointAngle = startAngle + DATA_POINT_OUTER_R / 2;
    var sin = Math.sin(-RADIAN * dataPointAngle);
    var cos = Math.cos(-RADIAN * dataPointAngle);
    var dataPointR = innerRadius + (outerRadius - innerRadius) / 2;
    var dataPointX = cx + dataPointR * cos;
    var dataPointY = cy + dataPointR * sin;
    return (<g id={"custom-active-shape-".concat(name)}>
      <Sector className="u-els-fill-n2" cx={cx} cy={cy} innerRadius={innerRadius} outerRadius={outerRadius} startAngle={startAngle} endAngle={endAngle} cornerRadius={cornerRadius || 0}/>
      {value > 0 && !hideIndicator && (<g>
          <circle cx={dataPointX} cy={dataPointY} r={DATA_POINT_OUTER_R} className={fillColorClass}/>
          <circle cx={dataPointX} cy={dataPointY} r={DATA_POINT_OUTER_R - DATA_POINT_STROKE_WIDTH} className="u-els-fill-white"/>
          <circle cx={dataPointX} cy={dataPointY} r={DATA_POINT_INNER_R} className={fillColorClass}/>
        </g>)}
    </g>);
};
export var buildDataForChart = function (value, total, pieces) {
    if (pieces && pieces.length) {
        var data_1 = [];
        var theRestOfValue_1 = value;
        var temptValue_1 = 0;
        var temptRest_1 = 0;
        var activeIndex_1 = 1;
        pieces.forEach(function (piece, idx) {
            if (theRestOfValue_1 > piece) {
                temptValue_1 = piece;
                temptRest_1 = 0;
                theRestOfValue_1 -= piece;
            }
            else {
                temptValue_1 = theRestOfValue_1;
                temptRest_1 = piece - theRestOfValue_1;
                theRestOfValue_1 = 0;
            }
            if (temptValue_1 > 0) {
                activeIndex_1 = idx + 1;
                data_1.push({
                    name: "value ".concat(idx),
                    value: temptValue_1
                });
            }
            if (temptRest_1 > 0) {
                data_1.push({
                    name: "rest ".concat(idx),
                    value: temptRest_1
                });
            }
        });
        return { data: data_1, activeIndex: activeIndex_1 };
    }
    return {
        data: [
            { name: 'value', value: value > 0 ? value : 0 },
            { name: 'rest', value: value > 0 ? total - value : 1 }
        ],
        activeIndex: 1
    };
};
